export class ValueToFormatedTextBaseValueConverter {
    toView(value, type) {
        switch(type) {
            case 0: value ? 'Yes' : 'No';
            default: return value;
        }
    }
}